import {
  NOTIFICATION_TYPE_ALARM,
  NOTIFICATION_TYPE_GIVE_BACK,
  NOTIFICATION_TYPE_NO_CLIENT,
  NOTIFICATION_TYPE_VOICE,
  NOTIFICATION_TYPE_PTT,
} from "@/utils/constants";
import { mapActions } from "vuex";
import { CHECK_NOTIFICATIONS } from "@/events/constants";
import { downloadPushToTalk } from "@/modules/pushtotalk/utils/s3.ts";

export default {
  methods: {
    ...mapActions("clientNotifications", ["answerNotification"]),

    handleNotificationClick(notification) {
      this.handleNotification(notification);
      this.openService(notification);
      if (this.close) {
        this.close();
      }
    },

    dismissNotification(notification) {
      this.answerNotification({
        data: {},
        params: { id: notification.inserted, wgId: notification.idWg },
      });
      if (this.close) {
        this.close();
      }
    },

    async handleNotification(notification) {
      switch (notification.type) {
        case NOTIFICATION_TYPE_VOICE:
        case NOTIFICATION_TYPE_ALARM:
          this.answerNotification({
            data: {},
            params: {
              id: notification.inserted,
              wgId: notification.idWg,
            },
          });
          break;
        case NOTIFICATION_TYPE_PTT:
          try {
            const blob = await downloadPushToTalk(notification.params.url);
            const audio = new Audio(URL.createObjectURL(blob));
            audio.play();
          } catch (e) {
            console.error(e);
          }
          this.answerNotification({
            data: {},
            params: {
              id: notification.inserted,
              wgId: notification.idWg,
            },
          });
          break;
      }
    },

    openService(notification) {
      let notificationType = notification.type;
      switch (notification.type) {
        case NOTIFICATION_TYPE_NO_CLIENT:
          notificationType = 5;
          break;
        case NOTIFICATION_TYPE_GIVE_BACK:
          notificationType = 6;
          break;
      }

      try {
        const params =
          typeof notification.params === "string"
            ? JSON.parse(notification.params)
            : notification.params;
        const { tripId } = params;
        if (tripId) {
          this.$router.push({
            path: "/services/edit",
            query: {
              id: tripId,
              wgId: notification.idWg,
              type_notification: notificationType,
              notification: notification.inserted,
            },
          });
        }
      } catch (e) {
        console.error(e);
      }
    },

    acceptNoClient(notification, ev) {
      ev.preventDefault();
      ev.stopPropagation();
      const params = {
        id: notification.inserted,
        wgId: notification.idWg,
      };
      this.callAnswerNotification({ answer: 1 }, params);
    },

    rejectNoClient(notification, ev) {
      ev.preventDefault();
      ev.stopPropagation();
      const params = {
        id: notification.inserted,
        wgId: notification.idWg,
      };
      this.callAnswerNotification({ answer: 0 }, params);
    },

    rejectGiveBack(notification, ev) {
      ev.preventDefault();
      ev.stopPropagation();
      const params = {
        id: notification.inserted,
        wgId: notification.idWg,
      };
      this.callAnswerNotification({ answer: 0 }, params);
    },

    refreshNotifications() {
      this.$bus.emit(CHECK_NOTIFICATIONS);
    },

    async callAnswerNotification(data, params) {
      const payload = {
        data: JSON.stringify(data),
        params,
      };
      await this.answerNotification(payload);
      this.$bus.emit(CHECK_NOTIFICATIONS);
    },
  },
};
